import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const ArrowDownIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "ArrowDownIcon", ...props, ref: ref, viewBox: "0 0 14 16", children: _jsx("g", { children: _jsx("polyline", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: props.strokeWidth, points: "3 6 7 10 11 6" }) }) })));
ArrowDownIcon.displayName = "ArrowDownIcon";
